import React, { Component } from 'react'
import Loader from 'react-loader-spinner'
import { connect } from 'react-redux'
import * as actions from '../redux/actions'
import VersionTagContainer from './globals/VersionTagContainer'
import { FaChevronDown, FaChevronUp } from 'react-icons/fa'
import Menu from '../services/Menu'

class Interface extends Component {
  state = {
    showMenu: false
  }

  goBack = () => {
    this.props.goBack
      ? this.props.goBack()
      : this.props.history.goBack()
  }

  render () {
    return (
      <div id='interface' style={{ flex: 1, width: '100%', height: '100%' }}>
        <header style={{ zIndex: this.state.showMenu && 1, width: '100%', display: 'flex' }}>
          <div id='icon'>
            {this.props.logoImg &&
              <img onClick={() => this.goBack()}
                src={`${window.location.origin}/${this.props.logoImg}`}
                alt='icon'
              />
            }
            {this.props.logoIcon &&
              <div onClick={() => this.goBack()}
                style={{display: 'flex', alignItems: 'center'}}
              >
                <div
                  style={{
                    width: 0,
                    height: 0,
                    borderTop: '6px solid transparent',
                    borderBottom: '6px solid transparent',
                    borderRight: '10px solid #fff',
                    marginLeft: '5px',
                    marginRight: '-2px'}}
                />
                <div
                  style={{ display: 'flex', alignItems: 'center', marginRight: '7px', backgroundColor: '#fff', borderRadius: '50%', padding: this.props.customPadding }}

                >
                  {this.props.logoIcon}

                </div>
              </div>
            }
          </div>
          {!this.props.renderMenu && <div id='title' style={{ flex: 1 }}><span>{this.props.title}</span></div>}
          {this.props.renderMenu &&
            <Menu
              trigger={open =>
                <div style={{ height: '100%', display: 'flex', flexGrow: 1, marginRight: 16 }}>
                  <div id='title' style={{ overflow: 'hidden' }}><span>{this.props.title}</span></div>
                  {this.props.renderMenu && <div id='icon-menu'>{open ? <FaChevronUp /> : <FaChevronDown />}</div>}
                </div>
              }
              onOpen={open => this.setState({ showMenu: open })}
              textParagraph={this.props.renderMenu}
            />
          }
          <div id='in-logo' style={{ marginRight: 12 }}>
            <img onClick={() => this.props.history.push('/')} src={`${window.location.origin}/assets/marca.png`} alt='logo' />
          </div>
        </header>
        <div id='in-content' className={this.props.backgroundClass ? this.props.backgroundClass : 'default-background'} style={{ position: 'relative', flex: 1, width: '100%', height: '100%' }}>
          <div style={{ position: 'absolute', top: 100, left: '50%', transform: 'translate(-50%, 0)' }}>
            {this.props.loading &&
              <Loader
                type='TailSpin'
                color='#6d357b'
                height='50'
                width='50'
              />
            }
          </div>
          {this.props.children}
        </div>
        {this.props.showFooter !== false &&
          <div id='footer'>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingLeft: '16px', paddingRight: '16px' }}>
              <div style={{ flex: 1 }} />
              <div id='goback'><img onClick={this.props.history.goBack} src={`${window.location.origin}/assets/setinhavoltar.png`} alt='GoBack' /></div>
              <VersionTagContainer />
            </div>
          </div>}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    ...state.userReducer
  }
}

export default connect(mapStateToProps, actions)(Interface)



// WEBPACK FOOTER //
// ./src/components/Interface.js